import { DataTable } from '@porsche-code/kado-ui';
import { createDataTableColumnHelper as createColumnHelper } from '@porsche-code/kado-ui';
import { createFileRoute, useParams } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { NAMESPACES } from '@/config/i18n';
import { PersonInfoQuery, usePersonInfoQuery } from '@/graphql';

export const Route = createFileRoute('/admin/person-info/$personId/groups')({
  component: Groups,
});

function Groups() {
  const { t } = useTranslation(NAMESPACES);

  const { personId } = useParams({
    from: '/admin/person-info/$personId/groups',
  });

  const { data: person, isPending } = usePersonInfoQuery(
    { id: +personId },
    {
      select: (data) => data.person,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
    },
  );

  const columns = useMemo(() => {
    const columnHelper =
      createColumnHelper<
        NonNullable<NonNullable<PersonInfoQuery['person']>['groups']>[0]
      >();

    return [
      columnHelper.accessor('id', {
        cell: (data) => data.getValue(),
        header: () => t('common:id'),
      }),
      columnHelper.accessor('name', {
        cell: (data) => data.getValue(),
        header: () => t('common:name'),
      }),
    ];
  }, [t]);

  return (
    <DataTable
      isLoading={isPending}
      caption={t('common:groups')}
      data={person?.groups ?? []}
      columns={columns}
      idAccessor="name"
      pagination={{
        active: false,
      }}
      i18n={{
        filterLabel: (columnName) =>
          t('common:iconLabel.filter', { columnName }),
        optionAll: t('common:all'),
        buttonReset: t('common:action.reset'),
        buttonFilter: t('common:action.filter'),
        actionSearch: t('common:action.search'),
        noData: t('common:noData'),
        minLabel: t('common:min'),
        maxLabel: t('common:max'),
      }}
    />
  );
}
